<app-section-home-banner></app-section-home-banner>

<app-section-home-buscador
  (on-select-item)="handleSelectItemBusqueda($event)"
  (on-submit)="handleSubmitBuscador($event)"></app-section-home-buscador>

<!-- <app-section-home-info-principal
  [cantidadUniversidades]="cantidadUniversidades$ | async"
  [cantidadCarreras]="cantidadCarreras$ | async"
></app-section-home-info-principal> -->
<app-section-home-info-principal></app-section-home-info-principal>

<app-section-home-links-destacados></app-section-home-links-destacados>

<app-section-footer></app-section-footer>
